module.exports = __webpack_public_path__ + "static/media/report_wouldnt_mention.0e04437d.svg";